import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Client } from 'src/app/pages/activity/models/Client';
import { VisitService } from 'src/app/services/visit/visit.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Problems } from 'src/app/services/interfaces/interfaces';

interface TipoContacto {
  value: string;
  viewValue: string;
}

interface TipoCotizacion {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-create-visit',
  templateUrl: './create-visit.component.html',
  styleUrls: ['./create-visit.component.scss']
})
export class CreateVisitComponent implements OnInit {

  toggle: boolean = false;

  tipoContactos: TipoContacto[] = [
    { value: 'presencial', viewValue: 'Presencial' },
    { value: 'mail', viewValue: 'Email' },
    { value: 'telefono', viewValue: 'Telefono' }
  ];

  tipoCotizacion: TipoCotizacion[] = [
    { value: 'mail', viewValue: 'Email' },
    { value: 'telefono', viewValue: 'Telefono' }
  ];

  problems_sell: Problems[] = [
    {
      nombre: 'tiene stock',
      value: {
        ID: 1,
        pvta_codigo: "0",
        ttdesc: '',
        pvta_tipo: "pvta",
        'ven-cod': 7
      }
    },
    {
      nombre: 'paso pedido',
      value: {
        ID: 1,
        pvta_codigo: "1",
        ttdesc: '',
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'sin necesidad',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "2",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'precio',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "3",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'diferente calidad o servicio',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "4",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'plazo entrega',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "5",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'modalidad competencia',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "6",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'no esta comprando',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "7",
        pvta_tipo: "pcob",
        'ven-cod': 7,
      }
    }
  ];

  problemas_cob: Problems[] = [
    {
      nombre: 'no debe',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "0",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'giraron',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "1",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'sin preparar',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "2",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'sin disponibilidad',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "3",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'giraran',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "4",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    }
  ];

  form: FormGroup;
  session: any;
  filtered: Client[];
  clients: Client[];

  now: Date = new Date();

  constructor(
    private builder: FormBuilder,
    private visitService: VisitService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    console.log(this.now);
    this.form = this.builder.group({
      ID: [1],
      'cli-cod': ['', Validators.required],
      'ven-cod': [''],
      vis_tipoContacto: [''],
      vis_fecha: [this.now, Validators.required],
      vis_otrosDatos: [''],
      vis_otrosDatos1: [''],
      vis_venta: [''],
      vis_cobranza: [''],
      vis_CotizTipo: [''],
      vis_cargaUsu: [''],
      vis_comentarios: [''],
      cli_cuit: [''],
      cli_dom: [''],
      cli_nombre: [''],
      vis_fechaCobro: [''],
      ttproblemas: [[]],
    });
    this.session = JSON.parse(sessionStorage.getItem('session'))['dsSesion'];
    this.clients = this.session['ttcliente'];
  }

  invalid(form: FormGroup) {

    if (typeof form.value['cli-cod'] != 'number') {
      console.log(0)
      return true;
    }

    if (form.value['cli-cod'] == 999999) {
      if (!form.value.cli_nombre) {
        console.log(1)
        return true;
      }

      if (!form.value.cli_dom) {
        console.log(2)
        return true;
      }
    }
    return false
  }

  create(form: FormGroup) {
    form.value['ven-cod'] = this.session['ttsesion'][0]['nro'];
    form.value.vis_cargaUsu = this.session['ttsesion'][0]['nombre'];
    this.visitService.create(form).subscribe((data) => {
      console.log(data);
      if (data['ttResponse'][0]['ttError']) {
        this.openSnackBar(data['ttResponse'][0]['ttMensaje'], 'Cerrar')
        return console.log(data);
      }
      this.openSnackBar('Visita creada correctamente', 'Cerrar')
      return this.dialog.closeAll();
    }, (callback) => {
      console.log(callback.error.message);
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  toggler() {
    return this.toggle = !this.toggle;
  }

  displayNm(code: any) {
    return code;
  }

  applyFilter(value: any) {
    if(value.length > 2) {
      const filterValue = value.toLowerCase();
      return this.filtered = this.clients.filter(client => client.nombre.toLowerCase().includes(filterValue.toLocaleLowerCase()) || client.codigo == value);
    }
  }

  leave(): void {
    this.dialog.closeAll();
  }

}
